// extracted by mini-css-extract-plugin
export default {"wrapper":"sortable__wrapper__x8r9A","item":"sortable__item__e5HhI","handle":"sortable__handle___Ybup","grabbable":"sortable__grabbable__sGBuV","disabled":"sortable__disabled__Bh0zj"};